"use client";
//#region packages/@mantine/core/src/components/Title/Title.module.css
var Title_module_default = { "root": "m_8a5d1357" };
//#endregion
export { Title_module_default as default };

//# sourceMappingURL=Title.module.mjs.map